import { render, staticRenderFns } from "./OnepersonOneFileJg.vue?vue&type=template&id=38416453"
import script from "./OnepersonOneFileJg.vue?vue&type=script&lang=js"
export * from "./OnepersonOneFileJg.vue?vue&type=script&lang=js"
import style0 from "./OnepersonOneFileJg.vue?vue&type=style&index=0&id=38416453&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports